export const LabelColors = [
  "#45d4ba",
  "#a870ef",
  "#cef06c",
  "#45d4ba",
  "#45d4ba",
  "#45d4ba",
  "#45d4ba",
  "#45d4ba",
  "#45d4ba",
  "#45d4ba",
  "#45d4ba",
];


export const Kermit = `
                     #########
                 ####         ###  ########
               ##                ##++++++++#####
              #     ########       #++++++++++++##########
             #     #######         ##++++++++###          ###
            #    #######          ##++++++++#                ##
            #   ##              ##+++++++++++#     ####        #
           #                ####++++++++++++++#      ######     #
           #             ###+++++++++++++++++++#      #####      #
         ##+###    ######+++++++++++++++++++++++#     #####      #
        #++++++####++++++++++++++++++++++++++++++#       ###     #
      ##++++++++++++++++++++++++++++++++++++++++++##      ##     #
    ##++++++++++++++++++++++++++++++++++++++++++++++##          ##
   #++++++++++++++++++++++++++++++++++++++++++++++++++###      #++#
  #++++++++++++++++++++++++++++++++++++++++++++++++++++++######++++#
 #++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++#
 #+++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++#
#++++++#++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++#
#++++##+++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++#
#+++##+++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++#
#+++#+++++++++++++++++++++++++++++++++++++++++++++++++++++++++++##+++++#
 #+++#++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++#++++#
 #+++#+++###+++++++++++++++++++++++++++++++++++++++++++++++++++++++#++++#
  #+++#++#XX###++++++++++++++++++++++++++++++++++++++++++++++++++++#++++#
   #++++++##xx####++++++++++++++++++++++++++++++++++++++####++++++##+++#
    #+++++++#xxxxx#####+++++++++++++++++++++++++++######XX#++++++##+++#
     #+++++++#xxxxxxxxx########++++++++++#########xxxxxx##++++++++++##
      ##++++++#xxxxxxxxxxxxxxxx##########xxxxxxxxxxxxx##+++++++++++#
        #++++++##xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx###+++++++++++##
         #+++++++#xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx##++++++++++++##
          #+++++++#xxxxxxxxxxxxxxxxxxxxxxxxxxxx##++++++++++++##
           #+++++++##xxxxxxxxxxxxxxxxxxxxxxxx##++++++++++++##
            ##+++++++#xxxxxxxxxxxxxxxxxxxxx##++++++++++++##
              ##++++++##xxxxxxxxxxxxxxxxx##++++++++++++##
                ##++++++##xxxxxxxxxxxxx##++++++++++++##
                  ##++++++###xxxxxxx###++++++++++++##
                    ##+++++++#######+++++++++++++##
                      ##+++++++++++++++++++++++##
                        ##+++++++++++++++++++##
                          ##+++++++++++++####
                            #############
`